export const LOADING_MESSAGE = 'Loading teams...';
export const NO_TEAMS_MESSAGE =
  'No teams found. Click "Add Team" below and start building your dream team now.';
